import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useId } from '@react-aria/utils';
import { useCallback, useState } from 'react';
import ReactCollapsible from 'react-collapsible';
import { ChevronDown } from '@calm-web/icons';
import { FontSizes } from '../../utils/typography';
import Text from '../Text';
import { getDefaultSize } from '../Text/styles';
import { HeaderElements } from '../Text/types';
import { CollapsibleInner, IconContainer, StyledTrigger } from './styles';
const CollapsibleTrigger = ({ trigger, isOpen, isDisabled, triggerTextColor, iconSize, iconColor, animationTimeMs, }) => {
    const content = (() => {
        if (typeof trigger === 'string') {
            return (_jsx(Text, { size: FontSizes.base, color: triggerTextColor, children: trigger }));
        }
        return trigger;
    })();
    return (_jsxs(StyledTrigger, { "$isDisabled": isDisabled, children: [isDisabled ? null : (_jsx(IconContainer, { "$size": iconSize, "$color": iconColor, "$isOpen": isOpen, "$animationTimeMs": animationTimeMs, children: _jsx(ChevronDown, {}) })), content] }));
};
const Collapsible = ({ className, trigger, triggerTextColor = 'collapsibleText', iconSize = FontSizes.base, iconColor = 'collapsibleIcon', isOpen: _isOpen, defaultOpen, isDisabled, onClick: _onClick, onOpened, onClosed, children, tabIndex = 0, }) => {
    const id = useId();
    const triggerId = useId();
    const [localIsOpen, setLocalIsOpen] = useState(defaultOpen !== null && defaultOpen !== void 0 ? defaultOpen : false);
    const isOpen = _isOpen !== null && _isOpen !== void 0 ? _isOpen : localIsOpen;
    const animationTimeMs = 200;
    const onClick = useCallback(() => {
        setLocalIsOpen(!localIsOpen);
        if (_onClick) {
            _onClick();
        }
    }, [localIsOpen, _onClick]);
    return (_jsx(ReactCollapsible, { trigger: _jsx(CollapsibleTrigger, { trigger: trigger, triggerTextColor: triggerTextColor, isOpen: isOpen, iconSize: iconSize, iconColor: iconColor, animationTimeMs: animationTimeMs, isDisabled: isDisabled }), triggerElementProps: { id: triggerId }, className: className, openedClassName: className, open: isOpen, triggerDisabled: isDisabled, handleTriggerClick: onClick, onOpen: onOpened, onClose: onClosed, transitionTime: animationTimeMs, easing: "ease-in-out", tabIndex: tabIndex, contentElementId: id, children: _jsx(CollapsibleInner, { "$isOpen": isOpen, children: children }) }));
};
export const CollapsibleSection = (_a) => {
    var { headerText, headerEl = HeaderElements.H3 } = _a, props = __rest(_a, ["headerText", "headerEl"]);
    const trigger = _jsx(Text, { el: headerEl, children: headerText });
    const iconSize = getDefaultSize(headerEl);
    return _jsx(Collapsible, Object.assign({ iconSize: iconSize }, props, { trigger: trigger }));
};
export default Collapsible;
//# sourceMappingURL=index.js.map